module.exports = ".aha-main-content-col{\n  background-color: #F6F6F6;\n  -webkit-transition: width .3s linear;\n  transition: width .3s linear;\n}\n\n.add-sidebar-animation{\n  -webkit-transition: width .3s linear;\n  transition: width .3s linear;\n}\n\n.aha-user-profile-row{\n  height: 50px;\n}\n\n.footer {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 60px;\n  background-color: #f5f5f5;\n  -webkit-transition: width .3s linear;\n  transition: width .3s linear;\n}\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main